import { v4 as uuidv4 } from "uuid";
export class AssetPropertiesDetailViewModel {
    constructor() {
        this.id = uuidv4();
        this.assetId = '';
        this.assetTypeId = '';
        this.assetTypePropertyName = '';
        this.value = '';
    }
}
export default class AssetPropertiesDetailView extends AssetPropertiesDetailViewModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
